import React from 'react';
import styled from '@emotion/styled';
import { OMGTheme } from '@ordermygear/theme';

const DescriptionContainer = styled.div`
  padding-left: 35px;
  p {
    margin: 5px;
    font-size: 12px;
    width: 160px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
  }
  p > span {
    font-weight: 500;
  }
  .item-title {
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media only screen and (max-width: ${OMGTheme.breakpoints.xs}) {
    padding-top: 10px;
    padding-left: 0;
  }
`;
interface ItemDescriptionProps {
  name: string;
  attributes: any;
}

const ItemDescription: React.FC<ItemDescriptionProps> = ({
  name,
  attributes
}) => {
  // putting color and size at the top
  const color = attributes.filter((option: any) => {
    return option.name.toLowerCase() === "color"
  })[0];
  const size = attributes.filter((option: any) => {
    return option.name.toLowerCase() === "size"
  })[0];
  const attributesMapped = attributes
    .filter((option: any) => option.name.toLowerCase() !== "color" && option.name.toLowerCase() !== "size")
    .map((option: any) => {
        return <p key={option.id}>{option.name}: <span>{option.value}</span></p>
    });
  return (
    <DescriptionContainer>
      <p className="item-title">{name}</p>
      {color && <p>Color: <span>{color.value}</span></p>}
      {size && <p>Size: <span>{size.value}</span></p>}
      {attributesMapped}
    </DescriptionContainer>
  );
};

export default ItemDescription;






